import { render, staticRenderFns } from "./safety-data.vue?vue&type=template&id=6af6a166"
import script from "./safety-data.vue?vue&type=script&lang=js"
export * from "./safety-data.vue?vue&type=script&lang=js"
import style0 from "./safety-data.vue?vue&type=style&index=0&id=6af6a166&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports